
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Options` type.
 */

type Options = {
  locale: string
};

/**
 * Export `fetchCountries`.
 */

export async function fetchCountries({ locale }: Options) {
  const endpoint = getApiEndpoint('getCountries');

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    handleRequestError(error);
  }
}
